export default __webpack_public_path__ + "static/media/slider-img3.38443f28.gif";